const interval = setInterval(() => {
    const redoEl = document.querySelector('redo-shopify-checkbox');
 
    if (redoEl && redoEl.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        ._5-4 {
          max-width: calc(100% - 100px);
        }
        div[data-target="checkbox-root"] {
          align-items: flex-start;
        }
        span[data-target="checkbox-label"] {
          flex: 0 0 auto !important;
          padding: 0 5px 0 0 !important;
        }
        span[data-target="checkbox-info"] {
          width: 16px;
          height: 16px;
        }
      `;
      redoEl.shadowRoot.appendChild(style);
      if(redoEl.shadowRoot.querySelector('[data-target="checkbox-label"]')){
        redoEl.shadowRoot.querySelector('[data-target="checkbox-label"]').innerHTML ="<strong> Add $5.98 Return Protection for Free 30-Day Return Shipping </strong>";
      clearInterval(interval);
      }
    }
}, 300);


// Select the elements
const interval_wrap = setInterval(() => {
  const redoCheckbox = document.querySelector("#redo-checkbox");
  const questionWrapper = document.querySelector(".question-wrapper");
  if (questionWrapper && document.querySelector("#redo-checkbox")) {
    clearInterval(interval_wrap)
  }
  
  
  const wrapper = document.createElement("div");
  wrapper.className = "redo-question-wrapper"; // optional class
  if(document.querySelector("#redo-checkbox")){
      document.querySelector("#redo-checkbox").classList.add("redo-question-wrapper")
      document.querySelector("#redo-checkbox").appendChild(questionWrapper);
   }
},200);

